import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
  OnInit,
  signal,
  ViewChild,
  DestroyRef
} from '@angular/core';
import SwiperCore, { Scrollbar } from 'swiper';
import { SwiperComponent, SwiperModule } from 'swiper/angular';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { AuthState } from '@app/modules/users';
import { days } from '@core/common/plurals';
import { Reward, RewardStatus } from '@app/modules/daily-rewards/daily-rewards.entity';
import { DailyRewardsState } from '@app/modules/daily-rewards/daily-rewards.state';
import { indicateLoading } from '@core/helpers';

import { BonusItemComponent } from '../bonus-item/bonus-item.component';

@Component({
  selector: 'bonuses-banner',
  templateUrl: './bonuses.component.html',
  styleUrl: './bonuses.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  
  imports: [SwiperModule, BonusItemComponent]
}) 
export default class BonusesBannerComponent implements OnInit, OnDestroy {
  public readonly state = inject(DailyRewardsState);
  private readonly destroyRef = inject(DestroyRef);
  public readonly isLoading = signal<boolean>(false);

  @ViewChild('swiperRef', { static: false })
  public swiper?: SwiperComponent;

  public readonly preloadRewards = new Array(14);

  public swiperProgress = signal(0);

  protected readonly daysPlurals = days;

  public readonly authState = inject(AuthState);
  
  ngOnDestroy(): void {
    this.state.reset();
  }

  ngOnInit(): void {
    this.state.load()
      .pipe(
        indicateLoading(this.isLoading),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();

    SwiperCore.use([Scrollbar]);

    this.changePositionProgressBar();
  }

  changePositionProgressBar(): void {
    if (this.isLoading() && this.state.progress()) {
      this.swiperProgress.set(this.state.progress());
    }
  }

  goToTopPrize(): void {
    if (this.swiper) {
      this.swiper.swiperRef.slideTo(this.state.rewards().length - 1); // Переход к последней награде
    }
  }

  isLastAndActive(rewards: Reward[], id: number): boolean {
    let lastActiveReward = null;
    let lastTakenReward = null;

    for (let i = rewards.length - 1; i >= 0; i--) {
      const reward = rewards[i];

      if (!lastActiveReward && (reward.status === RewardStatus.USABLE || reward.status === RewardStatus.AVAILABLE)) {
        lastActiveReward = reward;
      }

      if (!lastTakenReward && reward.status === RewardStatus.TAKEN) {
        lastTakenReward = reward;
      }

      if (lastActiveReward && lastTakenReward) {
        break;
      }
    }

    if (lastActiveReward && lastActiveReward.id === id) {
      return true;
    }

    return !!(!lastActiveReward && lastTakenReward && lastTakenReward.id === id);
  }
}
